<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="content-txt">
      <div class="t-image animate-target" v-animate-in>
        <img src="../../assets/images/Layer_1.png" />
        <div>1.3 million people in Australia have type 2 diabetes (T2D).<sup>1</sup></div>
      </div>
      <div class="t-text animate-target" v-animate-in>The RACGP recommend assessment of changes in kidney function as part of an annual cycle of care.<sup>2</sup></div>
      <ul class="txt-list">
        <li class="animate-target" v-animate-in>Urinalysis is recommended at least annually to examine:<sup>2</sup>
          <ul>
            <li class="animate-target" v-animate-in>– urinary albumin to creatine ratio (UACR)</li>
            <li class="animate-target" v-animate-in>– estimated glomerular filtration rate (eGFR).</li>
          </ul>
        </li>
        <li class="animate-target" v-animate-in>Any person with UACR or eGFR outside of target range should be followed up using an individualised assessment interval.<sup>2</sup></li>
        <li class="animate-target" v-animate-in>However, 1.1 million Australians living with diabetes do not have their kidney function checked within recommended time frames.<sup>3</sup></li>
      </ul>
    </div>
    <GoNext class="animate-target" v-animate-in href="/section2/2-2">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s2-1",
  components: {SectionTitle, GoNext, ContentNotice},
  data(){
    return {
      noticeTxt:"CV, cardiovascular; eGFR, estimated glomerular filtratio rate; RACGP, Royal Australian College of General Practitioner; T2D, type 2 diabetes; UACR, albumin-to-creatinine ratio.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. National Diabetes Service Scheme. NDSS Data Snapshots – Type 2 diabetes. Reporting as at 31 December 2024. <a target='_blank' class='c-url' href='https://snapshots.ndss.com.au/'>https://snapshots.ndss.com.au/</a>.<br/>"
      +"2. RACGP. Management of type 2 diabetes: A handbook for general practice. <a target='_blank' href='https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx' class='c-url'>https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>.<br/>"
      +"3. Change the future: Saving Lives by better detecting diabetes-related kidney disease. Diabetes Australia Report; 2023.",
      title:"Kidney function monitoring and management is a fundamental but inconsistently addressed part of diabetes care in Australia<sup>1–3</sup>"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section2/s2.css";
</style>
